import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  CCOrderCriterionType,
  ICCOrderCriterionTypes,
} from "src/Interfaces/ccOrder";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";

export const fallbackCCOrderCriterionTypes: ICCOrderCriterionTypes = {
  byProcess: {
    [DeltaHedgeOrderType.Open]: [
      {
        id: CCOrderCriterionType.MinDailyReturn,
        name: "حداقل % بازده روزانه",
      },
      {
        id: CCOrderCriterionType.MaxRollCost,
        name: "حداکثر بهای تمام شده",
      },
    ],
    [DeltaHedgeOrderType.Offset]: [
      {
        id: CCOrderCriterionType.MaxOffsetDailyReturn,
        name: "حداکثر % بازده روزانه آفست",
      },
      {
        id: CCOrderCriterionType.MaxRollCost,
        name: "حداکثر بهای تمام شده",
      },
    ],
    [DeltaHedgeOrderType.Roll]: [
      {
        id: CCOrderCriterionType.MaxRollCost,
        name: "حداکثر بهای تمام شده",
      },
      {
        id: CCOrderCriterionType.MinDailyRollReturn,
        name: "حداقل %بازده رول-روزانه",
      },
      {
        id: CCOrderCriterionType.RollTimeDecayInvolveddFundRatioDaily,
        name: "حداقل%بازده خالص ارزش زمانی  رول-روزانه",
      },
      {
        id: CCOrderCriterionType.DailyNetGainTimeRangeRollPercent,
        name: "حداقل%بازده ارزش زمانی طول رول- روزانه",
      },
    ],
  },
  defaults: {
    [DeltaHedgeOrderType.Open]: CCOrderCriterionType.MinDailyReturn,
    [DeltaHedgeOrderType.Offset]: CCOrderCriterionType.MaxOffsetDailyReturn,
    [DeltaHedgeOrderType.Roll]: CCOrderCriterionType.MaxRollCost,
  },
};

export function getCCOrderCriterionOptions(
  criterionTypes: ICCOrderCriterionTypes | null | undefined,
  process: DeltaHedgeOrderType | number | null | undefined,
): DropdownItem[] {
  const processKey = Number(process || -1);
  const fallbackOptions =
    fallbackCCOrderCriterionTypes.byProcess[processKey] || [];
  const options =
    criterionTypes?.byProcess?.[processKey] || fallbackOptions;

  return options.map((item) => {
    const fallbackName = fallbackOptions.find(
      (fallback) => fallback.id?.toString() === item.id?.toString(),
    )?.name;

    return fallbackName ? { ...item, name: fallbackName } : item;
  });
}

export function getDefaultCCOrderCriterionType(
  criterionTypes: ICCOrderCriterionTypes | null | undefined,
  process: DeltaHedgeOrderType | number | null | undefined,
): number | null {
  return (
    criterionTypes?.defaults?.[Number(process || -1)] ||
    fallbackCCOrderCriterionTypes.defaults[Number(process || -1)] ||
    null
  );
}

export function getCCOrderCriterionTypeName(
  criterionTypes: ICCOrderCriterionTypes | null | undefined,
  process: DeltaHedgeOrderType | number | null | undefined,
  criterionType: number | string | null | undefined,
): string {
  const resolvedCriterionType =
    criterionType || getDefaultCCOrderCriterionType(criterionTypes, process);

  return (
    getCCOrderCriterionOptions(criterionTypes, process).find(
      (item) => item.id?.toString() === resolvedCriterionType?.toString(),
    )?.name || ""
  );
}

